import { render, staticRenderFns } from "./AprobacionPage.vue?vue&type=template&id=afd230aa"
import script from "./AprobacionPage.js?vue&type=script&lang=js&external"
export * from "./AprobacionPage.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports